/* eslint
    no-empty-function: "warn",
*/

import { invoke } from '@shared/easyfy.decorators';
import Splide from '@splidejs/splide';
import { defaultTranslations } from '@webModules/splideHelper';

namespace Easyfy.Components {
  @invoke
  class ArticleListComponent {

    onInit() {
      ArticleListComponent.refreshArticleList();

      window.addEventListener('ArticleListComponent', ((event: CustomEvent) => {
        ArticleListComponent.refreshArticleList();
      }) as EventListener);
    }

    static refreshArticleList = (timeout: number = 0) => {
      setTimeout(() => {
        document
          .querySelectorAll('[data-container="articlelist-scroll"]')
          .forEach((item) => {
            item.classList.add('splide');
            let perView: number = parseInt(item.attributes['data-perview']?.value, 10);
            if (!perView) {
              perView = 3;
            }

            const slider = new Splide(item as HTMLElement, {
              type: 'loop',
              perPage: perView,
              speed: 500,
              dragMinThreshold: 20,
              flickMaxPages: 1,
              flickPower: 100,
              gap: 24,
              snap: false,
              arrows: true,
              pagination: false,
              breakpoints: {
                1100: {
                  perPage: 2,
                  arrows: true,
                  gap: 16,
                  pagination: false
                },
                768: {
                  arrows: false,
                  perPage: 1,
                  gap: 8,
                  padding: {
                    left: 0,
                    right: 80
                  }
                }
              },
              i18n: {
                ...defaultTranslations,
                prev: 'Föregående artikel',
                next: 'Nästa artikel',
                first: 'Gå till första artikeln',
                last: 'Gå till sista artikeln',
                slideX: 'Gå till artikel %s',
                carousel: 'artikelkarusell',
                select: 'Välj en artikel att visa',
                slide: 'artikel',
                slideLabel: 'Artikel %s av %s'
              }
            }).mount();
          });
      }, timeout);
    }
  }
}
